import {
    PROFILE_PICTURE_SUCCESS,
    PROFILE_PICTURE_IN_PROGRESS,
    PROFILE_PICTURE_ERROR,

    PROFILE_PICTURE_DIALOG_HIDE,
    PROFILE_PICTURE_DIALOG_SHOW,
    PROFILE_PICTURE_RESTORE,
    USER_OWNED_NFTS_IN_PROGRESS,
    USER_OWNED_NFTS_SUCCESS,
    USER_OWNED_NFTS_ERROR,
    UPDATE_USER_OWNED_NFTS_SEARCH,
    PREVIEW_URL_SET,
    AVATAR_UPLOAD_ERROR,
    AVATAR_UPLOAD_IN_PROGRESS,
    AVATAR_UPLOAD_SUCCESS,
} from '../../constants/account';
import Axios from 'axios';
import {
    getProfilePictureUrl,
    setProfilePicture,
    urlUserOwnedNFTs,
    AVATAR_UPLOAD_URL,
} from '../../constants/url';
import { handleErrorMessage } from '../../utils/errorMessages';

export const setPreviewURL = (value) => {
    return {
        type: PREVIEW_URL_SET,
        value,
    };
};

const getProfilePictureInProgress = () => {
    return {
        type: PROFILE_PICTURE_IN_PROGRESS,
    };
};

const getProfilePictureSuccess = (result) => {
    return {
        type: PROFILE_PICTURE_SUCCESS,
        result,
    };
};

const getProfilePictureError = (message) => {
    return {
        type: PROFILE_PICTURE_ERROR,
        message,
    };
};

export const getProfilePicture = (address, cb) => (dispatch) => {
    dispatch(getProfilePictureInProgress());

    const url = getProfilePictureUrl(address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    }).then((res) => {
        if (res && res.data && res.data.result) {
            dispatch(getProfilePictureSuccess(res.data.result));
            if (cb) {
                cb(res.data.result);
            }
        }
    }).catch((error) => {
        const message = handleErrorMessage(error);
        dispatch(getProfilePictureError(message));
        if (cb) {
            cb(null);
        }
    });
};

export const profilePictureReset = () => {
    return {
        type: PROFILE_PICTURE_RESTORE,
    };
};

export const showProfilePictureDialog = (value) => {
    return {
        type: PROFILE_PICTURE_DIALOG_SHOW,
        value,
    };
};

export const hideProfilePictureDialog = () => {
    return {
        type: PROFILE_PICTURE_DIALOG_HIDE,
    };
};

const profilePictureError = (message) => {
    return {
        type: PROFILE_PICTURE_ERROR,
        message,
    };
};

const profilePictureInProgress = () => {
    return {
        type: PROFILE_PICTURE_IN_PROGRESS,
    };
};

const profilePictureSuccess = (result) => {
    return {
        type: PROFILE_PICTURE_SUCCESS,
        result,
    };
};

export const profilePicture = (address, data) => (dispatch) => {
    dispatch(profilePictureInProgress());
    const url = setProfilePicture(address);
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(profilePictureSuccess(res.data && res.data.result, 'Asset Updated Successfully'));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(profilePictureError(message));
        });
};

export const updateUserOwnedNFTsSearch = (searchValue) => {
    return {
        type: UPDATE_USER_OWNED_NFTS_SEARCH,
        searchKey: searchValue,
    };
};

const getUserOwnedNFTsInProgress = () => {
    return {
        type: USER_OWNED_NFTS_IN_PROGRESS,
    };
};

const getUserOwnedNFTsSuccess = (result, skip, limit, total) => {
    return {
        type: USER_OWNED_NFTS_SUCCESS,
        result,
        skip,
        limit,
        total,
    };
};

const getUserOwnedNFTsError = (message) => {
    return {
        type: USER_OWNED_NFTS_ERROR,
        message,
    };
};

export const getUserOwnedNFTs = (address, skip, limit, search, cb) => (dispatch) => {
    dispatch(getUserOwnedNFTsInProgress());

    const url = urlUserOwnedNFTs(address, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    }).then((res) => {
        if (res && res.data && res.data.result) {
            dispatch(getUserOwnedNFTsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        }
    }).catch((error) => {
        const message = handleErrorMessage(error);
        dispatch(getUserOwnedNFTsError(message));
        if (cb) {
            cb(null);
        }
    });
};

const avatarUploadInProgress = () => {
    return {
        type: AVATAR_UPLOAD_IN_PROGRESS,
    };
};

const avatarUploadSuccess = (value) => {
    return {
        type: AVATAR_UPLOAD_SUCCESS,
        value,
    };
};

const avatarUploadError = (message) => {
    return {
        type: AVATAR_UPLOAD_ERROR,
        message,
        variant: 'error',
    };
};

export const avatarUpload = (file, cb) => (dispatch) => {
    dispatch(avatarUploadInProgress());
    const formData = new FormData();
    formData.append('file', file);
    Axios.post(AVATAR_UPLOAD_URL, formData, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(avatarUploadSuccess(res.data));
            cb(res.data);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(avatarUploadError(message));

            cb(null);
        });
};
